// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"96fc16c8","159":"27797c24","221":"aa1b9b90","356":"d3b603c6","384":"a3ca9c6c","412":"bfb63505","453":"bda8971a","663":"a42aa23a","788":"1e033d61"}[chunkId] + ".chunk.js";
};